<div>
  <kl-crop-form
    [profileKey]="profileKey"
    [cropFormDetails]="cropFormDetails"
    [pageId]="pageId"
    (closeDialog)="ok()">
  </kl-crop-form>
</div>
